/**
 * ImpersonationBanner — sticky strip across the top of the dashboard
 * when an owner/admin is viewing the app as another user. Makes it
 * impossible to forget you're impersonating, with a one-click exit.
 */
import { useQueryClient } from '@tanstack/react-query';
import { useImpersonation } from '@/lib/impersonation';

export function ImpersonationBanner() {
  const { target, stopViewAs } = useImpersonation();
  const queryClient = useQueryClient();

  if (!target) return null;

  return (
    <div className="sticky top-0 z-modal flex items-center justify-between gap-3 border-b border-warn/40 bg-warn/15 backdrop-blur-sm px-4 py-2 text-xs">
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <svg aria-hidden="true" className="text-warn shrink-0" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="4" /></svg>
        <span className="font-medium text-ink">
          Viewing as <span className="font-mono text-warn">{target.email}</span>
        </span>
        <span className="text-ink-dim hidden sm:inline">— every widget shows what they see. Logged in audit timeline.</span>
      </div>
      <button
        onClick={async () => {
          await stopViewAs();
          // Force every scoped query to refetch as the real user
          queryClient.invalidateQueries();
        }}
        className="rounded-md bg-warn px-3 py-1 text-2xs font-semibold text-on-fill hover:bg-warn/90 shrink-0"
      >
        Stop viewing as
      </button>
    </div>
  );
}
